// extracted by mini-css-extract-plugin
export var addButton = "_fw-4";
export var contentBlockImage = "_fw-i";
export var contentBlockWidgetPreview = "_fw-g";
export var fulfillmentCutoffWidgetPreview = "_fw-9";
export var imageBackdrop = "_fw-6";
export var imageIcon = "_fw-8";
export var lowProfileImageContainer = "_fw-b";
export var lowProfileImageIcon = "_fw-f";
export var lowProfileImageIconContainer = "_fw-e";
export var lowProfileImagePlaceholder = "_fw-d";
export var lowProfileProductImage = "_fw-c";
export var lowProfileProductUpsellWidgetPreview = "_fw-a";
export var productCard = "_fw-5";
export var productImage = "_fw-7";
export var productReviewsWidgetPreview = "_fw-h";
export var progressBar = "_fw-1";
export var progressBarFill = "_fw-2";
export var progressBarTrack = "_fw-3";
export var shippingOptionWidgetPreview = "_fw-j";
export var shippingUpsellProgressBar = "_fw-k";
export var thresholdUpsellWidgetPreview = "_fw-0";